import {
  Event,
  RailcarMovement,
  ReviewTimelineTick,
} from "src/store/api/generatedApi";

const labelValue = (event: Event, labelType: string): string | null =>
  event.labels.find((label) => label.data.label_type === labelType)?.data
    .label ?? null;

/** Build a timeline tick from a full event. Flags are left empty. */
export const eventToTimelineTick = (event: Event): ReviewTimelineTick => ({
  id: event.id,
  start: event.data.start,
  event_type: event.data.event_type,
  material: labelValue(event, "material"),
  area: labelValue(event, "area"),
  comment: labelValue(event, "comment"),
  flags: [],
  verified: false,
  targeted_review_reasons: [],
});

const railcarMaterialName = (movement: RailcarMovement): string =>
  movement.material.labelling_name ?? movement.material.name;

/**
 * Build timeline ticks for railcar movements: an arrival at the inbound time and,
 * when present, a departure at the outbound time. These are not labelling events,
 * so negative ids keep them from colliding with event ids used as render keys.
 */
export const railcarMovementsToTicks = (
  movements: RailcarMovement[]
): ReviewTimelineTick[] =>
  movements.flatMap((movement, index): ReviewTimelineTick[] => {
    const material = railcarMaterialName(movement);
    const arrival: ReviewTimelineTick = {
      id: -(2 * index + 1),
      start: movement.inbound_time,
      event_type: null,
      material,
      area: null,
      comment: null,
      flags: ["railcar_arrival"],
      verified: false,
      targeted_review_reasons: [],
    };
    if (movement.outbound_time === null) {
      return [arrival];
    }
    const departure: ReviewTimelineTick = {
      id: -(2 * index + 2),
      start: movement.outbound_time,
      event_type: null,
      material,
      area: null,
      comment: null,
      flags: ["railcar_departure"],
      verified: false,
      targeted_review_reasons: [],
    };
    return [arrival, departure];
  });
